import React, { useMemo } from 'react'
import { Flex, SkeletonLoader } from '@grammarly/design-system'
import { useIntl } from 'react-intl'

interface AIDetectorLoadingProps {
  numLoadingLines: number
  labelOffset?: number
}

export const AIDetectorLoading: React.FC<AIDetectorLoadingProps> = ({ numLoadingLines, labelOffset }) => {
  const intl = useIntl()
  const numLinesArray = useMemo(
    () => Array.from({ length: numLoadingLines || 10 }, () => Math.ceil(95 + 5 * Math.random())),
    [numLoadingLines]
  )

  const loadingLabel = intl.formatMessage({
    id: 'aiDetector.loading.label',
    description: 'AI Detector - Loading - Label',
    defaultMessage: 'Checking text for AI',
  })

  return (
    <Flex gap={5} justify="space-between">
      <SkeletonLoader accessibilityLabel={loadingLabel} label={loadingLabel} width="100%" labelOffset={labelOffset}>
        <Flex direction="column" gap={1} width="100%">
          {numLinesArray.map((percent, index) => (
            <SkeletonLoader.Text key={`skeleton-text-${index}`} variant="text-medium" width={`${percent}%`} />
          ))}
        </Flex>
      </SkeletonLoader>
    </Flex>
  )
}
